var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("create-dagontvangst")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-sale-type-select", {
                    attrs: {
                      "use-id": "",
                      fancy: "",
                      label: _vm.$ct("from-sale-type"),
                      "contact-group-id": 1,
                      "ignored-type-ids": [1, 2],
                    },
                    model: {
                      value: _vm.saleTypeId,
                      callback: function ($$v) {
                        _vm.saleTypeId = $$v
                      },
                      expression: "saleTypeId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-date-picker", {
                    attrs: { fancy: "", label: _vm.$ct("begin-date") },
                    model: {
                      value: _vm.beginDate,
                      callback: function ($$v) {
                        _vm.beginDate = $$v
                      },
                      expression: "beginDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-date-picker", {
                    attrs: { fancy: "", label: _vm.$ct("end-date") },
                    model: {
                      value: _vm.endDate,
                      callback: function ($$v) {
                        _vm.endDate = $$v
                      },
                      expression: "endDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "12" } },
                [
                  _c("w-date-picker", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("invoice-date-of-generated-invoice"),
                    },
                    model: {
                      value: _vm.invoiceDate,
                      callback: function ($$v) {
                        _vm.invoiceDate = $$v
                      },
                      expression: "invoiceDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.creating, icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }